import "core-js/stable";
import "regenerator-runtime/runtime";
import "intersection-observer"; // Optional

import Vue from "vue";
import "./plugins/bootstrap-vue";

import BaseFragment from "./components/UI/BaseFragment.vue";
import BasePopover from "./components/UI/BasePopover.vue";
import BaseModal from "./components/UI/BaseModal.vue";
import SButton from "./components/UI/SButton.vue";

import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

import { store } from "./store/store";
import * as filters from "./mixins/filters";
import * as methods from "./mixins/methods";

import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";

if (process.env.NODE_ENV === "production") {
	Sentry.init({
		Vue,
		dsn:
			"https://b9b555bba86941f393ccdef55dec7628@o326214.ingest.sentry.io/5583658",
		autoSessionTracking: true,
		logErrors: true,
		tracesSampleRate: 1.0,
		environment: process.env.NODE_ENV,
		integrations: [new Integrations.BrowserTracing()],
		tracingOptions: {
			trackComponents: true
		}
	});
}

Vue.config.productionTip = false;

Vue.mixin({
	filters: { ...filters, ...methods },
	methods: { ...filters, ...methods }
});

// Global registration
Vue.component("Fragment", BaseFragment);
Vue.component("BaseModal", BaseModal);
Vue.component("BasePopover", BasePopover);
Vue.component("SButton", SButton);

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount("#app");
